import { mapActions, mapState } from 'vuex'
import tenvideo from '@tencent/vft-common/tenvideo'
import login from '@tencent/vft-common/login'
import cookie from '@tencent/vft-common/cookie'
import openApp from '@tencent/vft-common/openapp'
import env from '@tencent/vft-common/env'
import urlFactory from '@tencent/vft-common/urlFactory'
import util from '@tencent/vft-common/util'
import LoginPanel from '@tencent/vft-vue-plugins/src/login'
import Vue from 'vue'
const normalizer = urlFactory.createNormalizer()
Vue.use(LoginPanel)
const VM = new Vue()

const mixin = {
  data () {
    return {
      defaultAvatar: '//i.gtimg.cn/qqlive/images/20150608/avatar.png'
    }
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo',
      payVipInfo: 'payVip'
    }),
    cid () {
      return util.getUrlParam('cid')
    },
    giveuin () {
      return util.getUrlParam('giveuin')
    },
    taskid () {
      return util.getUrlParam('taskid')
    },
    isTakeUser () {
      return this.taskid && this.giveuin
    }
  },
  methods: {
    ...mapActions([
      'getUserInfo',
      'getPayVip'
    ]),
    isLogin (isStrict = false) {
      if (!isStrict) {
        return Promise.resolve(login.isLogin())
      }
      return new Promise((resolve) => {
        login.isStrictLogin((isLogin) => {
          return resolve(isLogin)
        })
      })
    },
    loginType () {
      return login.loginType()
    },
    logout () {
      if (env.isMqq) {
        // 手Q中屏蔽退出登录
        return
      }
      return new Promise((resolve, reject) => {
        VM.confirm({
          title: '退出登录',
          msg: '您确定要退出登录吗？',
          confirm () {
            login.logout(() => {
              location.reload()
            })
          },
          cancel () {
            reject()
          }
        })
      })
    },
    openLogin (params) {
      if (params && params.type) {
        VM.$switchLogin(params)
      } else {
        VM.$openLogin(params)
      }
    },
    openUrl (url) {
      if (tenvideo.isAllTenvideo()) {
        tenvideo.openUrl(url)
      } else {
        window.location.href = url
      }
    },
    async openApp (url) {
      if (tenvideo.isAllTenvideo()) {
        this.openUrl(url)
        return
      }
      if (openApp.canGetInstallState) {
        if (await openApp.getInstallState()) {
          const res = await openApp.launch(url)
          console.log(res)
        } else {
          openApp.download()
        }
      } else {
        if (await openApp.launch(url)) {
          // 有安装
        } else {
          // 无安装
          openApp.download()
        }
      }
    },
    normalize (url) {
      return normalizer(url, 'https')
    },
    isApp () {
      return env.isApp
    },
    getUrlParam (param) {
      return util.getUrlParam(param)
    },
    goToPay () {
      login.isStrictLogin((isStrict) => {
        if (isStrict) {
          var ru = ['//film.qq.com/weixin/givemovie.html?cid=', this.cid].join('')
          location.href = ['//film.qq.com/weixin/upay.html?ptag=givemovie&ru=', encodeURIComponent(ru)].join('')
        } else {
          login.openLogin()
        }
      })
    },
    openMore () {
      if (env.isApp) {
        var filter = 'channel_type=movie&sort=17&iarea=-1&itype=-1&iyear=-1&iattribute=-1&type=1&iawards=-1'
        var url_app = ''
        if (env.isAndroid) {
          url_app = ['txvideo://v.qq.com/VideoListExhibitActivity?&channelId=100120&filter=', encodeURIComponent(filter), '&channelTitle=VIP影院&uiType=6'].join('')
        } else {
          url_app = ['tenvideo2://?action=3&channelId=100120&filter=', encodeURIComponent(filter), '&channelTitle=VIP影院&uiType=6'].join('')
        }

        if (login.isLogin()) {
          if (login.loginType() === 'wx') {
            var vuserid = cookie.get('vuserid')
            var nickName = this.userInfo.nick
            url_app += ['&userid=', vuserid, '&userType=wx', '&nickName=', encodeURIComponent(nickName)].join('')
            this.openUrl(url_app)
          } else {
            var uin = login.getUin()
            url_app += ['&userid=', uin, '&userType=qq'].join('')
            this.openUrl(url_app)
          }
        } else {
          this.openUrl(url_app)
        }
      } else {
        location.href = '//film.qq.com/weixin/all.html'
        return false
      }
    }
  }
}

export default mixin
